import React from "react";

export const useSearchOptions = <SearchT>() => {
  const [searchOptions, setSearchOptions] = React.useState<
    SearchT | undefined
  >();

  return { searchOptions, setSearchOptions };
};
